function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.105h30v15.789H0V7.105Z",
    style: {
      fill: "#75b2dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15 8.684 14.646 9.775 13.498 9.775 14.427 10.45 14.072 11.541 15 10.867 15.928 11.541 15.573 10.45 16.502 9.775 15.354 9.775 15 8.684",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.225 15.354 21.316 15 20.225 14.646 20.225 13.498 19.55 14.427 18.459 14.072 19.133 15 18.459 15.928 19.55 15.573 20.225 16.502 20.225 15.354",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.573 19.55 15.928 18.459 15 19.133 14.072 18.459 14.427 19.55 13.498 20.225 14.646 20.225 15 21.316 15.354 20.225 16.502 20.225 15.573 19.55",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "10.45 14.427 9.775 13.498 9.775 14.646 8.684 15 9.775 15.354 9.775 16.502 10.45 15.573 11.541 15.928 10.867 15 11.541 14.072 10.45 14.427",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFm);
export default __webpack_public_path__ + "static/media/FM.94e7d7fe6893644a7eee5003a8eb7a81.svg";
export { ForwardRef as ReactComponent };